module.exports = __webpack_public_path__ + "static/media/Group (1).1647f11c.svg";